import { AutoMap } from "@automapper/classes"
import { Temporal } from "@js-temporal/polyfill"
import { ETaskStatus } from "../models/enums/task-status"
import { PrelevementAir } from "./Air/prelevement-air"
import { PrelevementQualifSalle } from "./Qualif/prelevement-qualif-salle"
import { PrelevementSurface } from "./Surface/prelevement-surface"
import { BaseDOM } from "./base.dom"
import { EConditionPrelevement } from "./enums/condition-prelevement"

export class Zone extends BaseDOM<Zone> {
    @AutoMap()
    Code: string = ''
    @AutoMap()
    TaskStatus: ETaskStatus = ETaskStatus.New
    @AutoMap()
    ZoneSalle: string = ''
    @AutoMap()
    DateDernierLavage?: Temporal.PlainDateTime;
    @AutoMap()
    SamplingDate?: Temporal.PlainDateTime;
    @AutoMap()
    ConditionPrelevement: EConditionPrelevement = EConditionPrelevement.HorsActivite

    @AutoMap() 
    PrelevementQualifSalle?: PrelevementQualifSalle 
    @AutoMap(() => [PrelevementAir])
    PrelevementAirList: PrelevementAir[] = [];
    @AutoMap(() => [PrelevementSurface])
    PrelevementSurfaceList: PrelevementSurface[] = [];

}